import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { FiX } from "react-icons/fi";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import "./MobileMenu.css";

export default function MobileMenu({ open, onClose, links }) {
  const closeRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    closeRef.current?.focus();
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  return (
    <div
      id="mobile-menu"
      className={`mobile-menu ${open ? "mobile-menu--open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-label="Mobile navigation"
    >
      <div className="mobile-menu__header container">
        <span className="mobile-menu__logo">FIRM<span>FIT</span>FACTORY</span>
        <button ref={closeRef} type="button" className="mobile-menu__close" onClick={onClose} aria-label="Close menu">
          <FiX aria-hidden="true" />
        </button>
      </div>

      <nav className="mobile-menu__links container" aria-label="Mobile navigation links">
        {links.map((link, i) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === "/"}
            onClick={onClose}
            className={({ isActive }) => `mobile-menu__link ${isActive ? "mobile-menu__link--active" : ""}`}
            style={{ transitionDelay: `${i * 40}ms` }}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>

      <div className="mobile-menu__footer container">
        <a href="tel:+919500886368" className="btn btn-primary">Call +91 95008 86368</a>
        <div className="mobile-menu__socials">
          <a href="https://instagram.com/firmfitfactory" aria-label="Instagram (placeholder link)"><FaInstagram aria-hidden="true" /></a>
          <a href="https://facebook.com/firmfitfactory" aria-label="Facebook (placeholder link)"><FaFacebookF aria-hidden="true" /></a>
          <a href="https://wa.me/919500886368" aria-label="WhatsApp"><FaWhatsapp aria-hidden="true" /></a>
        </div>
      </div>
    </div>
  );
}
